import React from 'react'

import { Text, Tooltip } from '@driftt/dds'

import useOrgUsers from 'hooks/useOrgUsers'
import summarizeList from 'utils/summarizeList'

interface UserListTooltipProps {
  userIds: number[]
}

export default function UserListTooltip({
  userIds,
  children,
}: React.PropsWithChildren<UserListTooltipProps>) {
  const orgUsers = useOrgUsers()

  const userNames = orgUsers
    .filter((user) => userIds.includes(user.id))
    .map((user) => user.name || user.email || 'Unknown User')

  const tooltipContent = (
    <Text isPrivate>{summarizeList(['You', ...userNames])}</Text>
  )

  return (
    <Tooltip side="top" content={tooltipContent}>
      <div>{children}</div>
    </Tooltip>
  )
}
